var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(4 4)",
    style: {
      fill: "#2fcfac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.237 15.775 4.673-6.952a.532.532 0 0 0-.141-.733.526.526 0 0 0-.73.142l-4.3 6.4-1.826-2a.525.525 0 0 0-.743-.029.533.533 0 0 0-.029.747l2.273 2.484a.461.461 0 0 0 .062.045c.013.01.02.025.034.034s.022.008.033.014a.479.479 0 0 0 .11.046.537.537 0 0 0 .088.021.571.571 0 0 0 .1 0 .469.469 0 0 0 .1-.017.416.416 0 0 0 .081-.032.49.49 0 0 0 .1-.064c.009-.008.021-.01.03-.018a.377.377 0 0 0 .027-.038c.021-.015.043-.025.058-.05z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.2cb45ee7efb5de2b2f2c1e3273edd7e9.svg";
export { ForwardRef as ReactComponent };